<template>
  <div class="vlog-player">
    <Modal
      :isOpen.sync="isOpen"
      id="vlog-player"
      size="extra-large"
      class="vlog-player-modal"
    >
      <div>
        <div v-if="loading" class="text-center p-5 spinner-wrapper">
          <div class="spinner-border spinner-border-lg" role="status"></div>
        </div>
        <iframe
          v-if="external_url"
          :src="external_url"
          frameborder="0"
          class="preview-iframe"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
          allowfullscreen
        ></iframe>
        <div class="alert alert-danger" v-if="external_url_error">
          Error loading video
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isOpen: false,
      data: {},
      loading: true,
      external_url: null,
      external_url_error: false,
    };
  },
  mounted() {
    this.$root.$on("playVlog", this.playVlog);
  },
  methods: {
    playVlog(data) {
      this.isOpen = true;
      this.data = data;
      this.loading = true;
      this.external_url = null;
      this.external_url_error = false;

      this.$nextTick(() => {
        setTimeout(() => {
          this.loading = false;

          if (data.external_url) {
            this.external_url = data.external_url;
          } else {
            this.external_url_error = true;
          }
        }, 500);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$height: calc(var(--vh, 1vh) * 90);
.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: $height;
  background-color: var(--card-color);
}
.preview-iframe {
  width: 100%;
  height: $height;
  border: none;
  border-radius: var(--border-radius);
  background-color: var(--lighter);
  box-shadow: var(--box-shadow);
}
</style>